const JSEncrypt = require("./jsencrypt.min.js");
import dayjs from "dayjs";

const splitString = function (str, length) {
    const result = [];
    for (let i = 0; i < str.length; i += length) {
        result.push(str.substring(i, i + length));
    }
    return result;
};

// 授权的校验放在画布内了
export const checkAccessKey = function (accessKey) {
    window.EDCONFIG.LICENSE_KEY = accessKey;
    window.JSEncrypt = JSEncrypt;
};
